var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLupa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5L13.8809 13.8808M13.8809 13.8808C14.5 13.2618 14.991 12.5268 15.3261 11.718C15.6611 10.9091 15.8336 10.0422 15.8336 9.16667C15.8336 8.29116 15.6611 7.42424 15.3261 6.61538C14.991 5.80652 14.5 5.07157 13.8809 4.4525C13.2618 3.83343 12.5269 3.34235 11.718 3.00731C10.9091 2.67227 10.0422 2.49983 9.16672 2.49983C8.29121 2.49983 7.42429 2.67227 6.61543 3.00731C5.80657 3.34235 5.07162 3.83343 4.45255 4.4525C3.20227 5.70277 2.49988 7.39851 2.49988 9.16667C2.49988 10.9348 3.20227 12.6306 4.45255 13.8808C5.70282 15.1311 7.39856 15.8335 9.16672 15.8335C10.9349 15.8335 12.6306 15.1311 13.8809 13.8808Z",
    stroke: "#5BCD15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.fd1f6fc64a70126b7f1b65c61aac0e0c.svg";
export { ForwardRef as ReactComponent };